import { useState } from "react";
import { IconButton, InputAdornment } from "@mui/material"
import BaseInput from "../BaseInput"
import { Visibility, VisibilityOff } from "@mui/icons-material";

const InputPassword = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  }

  return (
    <BaseInput
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: 
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
      }}
      {...props}
    />
  )
}

export default InputPassword